import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { CustomizationService } from '../../../../admin360/customization/customization.service';
import { ViewDesignPagesComponent } from '../view-design-pages.component';

@Component({
  selector: 'app-view-design-pages-modal',
  templateUrl: './view-design-pages-modal.component.html',
  styleUrls: ['./view-design-pages-modal.component.css']
})
export class ViewDesignPagesModalComponent implements OnInit {

  designPageId: number;
  pageTitle = 'Design Pages';
  subtitle = '';
  designPageUpdated = false;
  @ViewChild(ViewDesignPagesComponent, { static: true }) viewDesignPagesComponent: ViewDesignPagesComponent;

  public get showAddButton(): boolean {
    let showButton = false;
    if (this.viewDesignPagesComponent) {
      showButton = this.viewDesignPagesComponent.userCanEdit && this.viewDesignPagesComponent.allowViewEdit
    }
    return showButton;
  }

  constructor(
    private dialogRef: MatDialogRef<ViewDesignPagesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customizationService: CustomizationService
  ) {
    if (data) {
      this.designPageId = data.designPageId;
      this.pageTitle = data.pageTitle;
    }
  }

  ngOnInit(): void {
    this.getSubTitle();
  }

  getSubTitle() {
    this.customizationService.getDesignPageByIDs(true, [this.designPageId], false).pipe(take(1)).subscribe(pages => {
      if (pages && pages.length > 0) {
        const p = pages[0];
        this.subtitle = p.ModuleName + ': ' + p.ObjectName + ' - ' + p.Name;
      }     
    });
  }

  closeClick() {
    this.dialogRef.close(this.designPageUpdated);
  }

  designPageUpdatedHandler() {
    this.designPageUpdated = true;
  }

  addClick() {
    if (this.viewDesignPagesComponent) {
      this.viewDesignPagesComponent.addVersion();
    }
  }

}
